/// <amd-module name="Test/LabelledContextualMenu/LabelledContextualMenu" />
import { CommandBarButton } from "OfficeFabric/Button";
import { DirectionalHint } from "OfficeFabric/Callout";
import { IContextualMenuItem } from "OfficeFabric/ContextualMenu";
import { IIconProps } from "OfficeFabric/Icon";
import { Label } from "OfficeFabric/Label";
import * as React from "react";
import { IVssComponentProperties, VssComponent } from "VSS/Platform/Layout";
import { ITooltipProps, Tooltip } from "VSSUI/TooltipEx";
import { css } from "VSSUI/Util";

export interface ILabelledContextualMenuProps extends IVssComponentProperties {
    options: IContextualMenuItem[];
    selectedOptionsText: string;
    contextualMenuAriaLabel?: string;
    onChange?: (ev?: React.MouseEvent<HTMLElement>, item?: IContextualMenuItem) => void;
    label?: string;
    iconProps?: IIconProps /* The props for the icon shown in the button. */;
    contextualMenuClassName?: string;
    optionsCssClassName?: string;
    labelCssClassName?: string;
    directionHint?: DirectionalHint;
    tooltipProps?: ITooltipProps;
    ariaPosinset?: number;
    ariaSetsize?: number;
}

export class LabelledContextualMenu extends VssComponent<ILabelledContextualMenuProps, {}> {
    private _emptyString: "";

    constructor(props: ILabelledContextualMenuProps) {
        super(props);
    }

    public render(): JSX.Element {
        let contextualMenu = (
            <div className={css("test-labelledContextualMenu", this.props.contextualMenuClassName || this._emptyString)} role={'menu'}>
                {this.props.label && (
                    <Label className={css("labelledContextualMenu-label", this.props.labelCssClassName || this._emptyString)}>
                        {this.props.label}
                    </Label>
                )}
                <CommandBarButton
                    className={css("labelledContextualMenu-options", this.props.optionsCssClassName || this._emptyString)}
                    text={this.props.selectedOptionsText || this._emptyString}
                    iconProps={this.props.iconProps}
                    ariaLabel={this.props.contextualMenuAriaLabel}
                    menuProps={{
                        items: this.props.options,
                        directionalHint: this.props.directionHint,
                        onItemClick: this.props.onChange
                    }}
                    role="menuitem"
                    aria-posinset={this.props.ariaPosinset}
                    aria-setsize={this.props.ariaSetsize}
                />
            </div>
        );

        if (this.props.tooltipProps) {
            contextualMenu = <Tooltip {...this.props.tooltipProps}>{contextualMenu}</Tooltip>;
        }

        return contextualMenu;
    }
}
